// import React from "react";
//
// export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;
//
// export const Label: React.FC<LabelProps> = ({ className, ...props }) => (
//   <label
//     {...props}
//     className={["label", className].filter(Boolean).join(" ")}
//   />
// );

// import React from "react";
//
// export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;
//
// export const Label: React.FC<LabelProps> = (props) => <label {...props} />;

import React from "react";

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export const Label: React.FC<LabelProps> = ({ className, children, ...props }) => (
  <label className={className} {...props}>
    {children}
  </label>
);